<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16763_30970"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" class="fill" />
    </mask>
    <g mask="url(#mask0_16763_30970)">
      <rect
        x="3.25"
        y="6"
        width="13.5"
        height="11.25"
        rx="2"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M3.25 9C3.25 8.06812 3.25 7.60218 3.40224 7.23463C3.60523 6.74458 3.99458 6.35523 4.48463 6.15224C4.85218 6 5.31812 6 6.25 6H13.75C14.6819 6 15.1478 6 15.5154 6.15224C16.0054 6.35523 16.3948 6.74458 16.5978 7.23463C16.75 7.60218 16.75 8.06812 16.75 9V9H3.25V9Z"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M6.25 3.75L6.25 6"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <path
        d="M13.75 3.75L13.75 6"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <rect
        x="6.25"
        y="10.5"
        width="3"
        height="1.5"
        rx="0.5"
        fill="#666666"
        stroke="#666666"
        stroke-width="0.2"
        class="fill"
      />
      <rect
        x="6.25"
        y="13.5"
        width="3"
        height="1.5"
        rx="0.5"
        fill="#666666"
        stroke="#666666"
        stroke-width="0.2"
        class="fill"
      />
      <rect
        x="10.75"
        y="10.5"
        width="3"
        height="1.5"
        rx="0.5"
        fill="#666666"
        stroke="#666666"
        stroke-width="0.2"
        class="fill"
      />
      <rect
        x="10.75"
        y="13.5"
        width="3"
        height="1.5"
        rx="0.5"
        fill="#666666"
        stroke="#666666"
        stroke-width="0.2"
        class="fill"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
